/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Stat/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Stat({
  children,
  viewPath = "/DesignSystem/Stat",
  color,
  fontSize,
  fontWeight,
  lineHeight,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  text = "Info",
  textAlign = "left",
  hyphens = "none",
  textOverflow = "ellipsis",
  whiteSpace = "nowrap",
  overflowX = "hidden"
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtTypographyFontsizeXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.xl'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtTypographyLineheightXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.xl'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={color || dtColorsNeutral700}
 fontSize={fontSize || dtTypographyFontsizeXl}
 fontWeight={fontWeight || dtTypographyFontweightRegular}
 lineHeight={lineHeight || dtTypographyLineheightXl}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 text={text}
 textAlign={textAlign}
 hyphens={hyphens}
 textOverflow={textOverflow}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
/>
{children}
</React.Fragment>)
}